// extracted by mini-css-extract-plugin
export default {"Container":"ExclusiveAccess_Container__tj5Wd"};